import apis from './config';

const legalApi = apis.legalSection;

// The tabs of the public footer's "Termos e Políticas" modal. Hidden sections
// are included: the backoffice list is where one is switched back on.
export const fetchLegalSections = async () => {
    try {
        const response = await legalApi.get('/', { headers: { Accept: 'application/json' } });
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error('Error fetching legal sections:', error);
        throw error;
    }
};

// { title, content, isVisible, sortOrder } — created hidden unless told
// otherwise, so an empty tab never shows up on the site.
export const createLegalSection = async (section) => {
    try {
        const response = await legalApi.post('/', section, { retag: true, validateCsrf: true });
        return response.data;
    } catch (error) {
        console.error('Error creating legal section:', error);
        throw error;
    }
};

// Any subset of { title, content, isVisible, sortOrder }. The footer is part of
// every rendered page, so the server rebuilds the whole site before responding.
export const updateLegalSection = async (id, changes) => {
    try {
        const response = await legalApi.patch(`/${id}`, changes, { retag: true, validateCsrf: true });
        return response.data;
    } catch (error) {
        console.error('Error updating legal section:', error);
        throw error;
    }
};

export const deleteLegalSection = async (id) => {
    try {
        const response = await legalApi.delete(`/${id}`, { retag: true, validateCsrf: true });
        return response.data;
    } catch (error) {
        console.error('Error deleting legal section:', error);
        throw error;
    }
};
